<template>
  <div
    class="gmfo"
    v-html="gmfName"
  ></div>
</template>

<script>
import { getGameformat, getGameformatOptionHtml } from '@/store/gameformat/gameformat'

export default {
  name: 'GameFormatOption',
  props: {
    namespace: String,
    customItem: Object,
    omitKeys: { default: () => ['cash69max_type'] },
    includeKeys: Array,
  },
  data() {
    return {}
  },

  computed: {
    gmfName() {
      const res = getGameformatOptionHtml({
        gameformat: this.gameformat,
        omitKeys: this.omitKeys,
        includeKeys: this.includeKeys,
      })
      return res
    },
    gameformat() {
      if (this.customItem) {
        return this.customItem
      }
      if (this.namespace) {
        const { gameformats } = this.$store.getters
        const query_gameformat = this.$store.getters[`${this.namespace}/query_gameformat`]
        const res = getGameformat({ item: query_gameformat, gameformats })
        return res
      }
      const res = this.$store.getters.gameformat
      return res
    },
  },
}
</script>
